import { render } from "./IncidentsPage.vue?vue&type=template&id=3ee6970b&scoped=true"
import script from "./IncidentsPage.vue?vue&type=script&lang=js"
export * from "./IncidentsPage.vue?vue&type=script&lang=js"

import "./IncidentsPage.vue?vue&type=style&index=0&id=3ee6970b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee6970b"]])

export default __exports__